'use client'
import { cn } from '~/lib/utils'
import { ChevronDown } from 'lucide-react'
import Link from 'next/link'
import React from 'react'
import { ResCategory } from '~/types/category'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '~/components/ui/dropdown-menu'

import { Button } from '~/components/ui/button'

interface Props {
    categories: ResCategory[]
}
const Category: React.FC<Props> = ({ categories }) => {
    return (
        <div>
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <Button variant={'ghost'} className='rounded-lg h-auto py-1.5 px-2.5 gap-x-1 font-normal'>
                        Danh mục
                        <ChevronDown className='mt-0.5 size-4' />
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align='end' className='rounded-lg p-0 mt-2 max-w-36'>
                    <CategoryContent categories={categories} />
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    )
}

export default Category

export const CategoryContent: React.FC<Props> = ({ categories }) => {
    return (
        <div
            className={cn(
                'max-w-36 p-1.5 capitalize'
            )}
        >
            {categories.map((category) => (
                <Link
                    key={category.id.toString()}
                    href={`/${category.slug}`}
                >
                    <DropdownMenuItem className='rounded-md px-3 py-1.5 font-normal'>
                        {category.name}
                    </DropdownMenuItem>
                </Link>
            ))}
        </div>
    )
}
